module.exports = __webpack_public_path__ + "media/src/application/media/rooms/many_function1-191ba77edd8a9961ac733082c2e54f24.png";